import React, { Component } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { BsBackspace } from 'react-icons/bs';
// import { MdSubdirectoryArrowLeft, MdKeyboardBackspace, MdClose } from "react-icons/md";

class Keypad extends Component {

    render() {
        const { result, mode } = this.props;
        return (
            <>
                <Row className="text-center mt-3">
                    <Col>
                        <Button block variant="outline-primary" id="1" name="1" onClick={e => this.props.onClick(e.target.name)}>1</Button>
                    </Col>
                    <Col>
                        <Button block variant="outline-primary" id="2" name="2" onClick={e => this.props.onClick(e.target.name)}>2</Button>
                    </Col>
                    <Col>
                        <Button block variant="outline-primary" id="3" name="3" onClick={e => this.props.onClick(e.target.name)}>3</Button>
                    </Col>
                </Row>
                <Row className="text-center mt-3">
                    <Col>
                        <Button block variant="outline-primary" id="4" name="4" onClick={e => this.props.onClick(e.target.name)}>4</Button>
                    </Col>
                    <Col>
                        <Button block variant="outline-primary" id="5" name="5" onClick={e => this.props.onClick(e.target.name)}>5</Button>
                    </Col>
                    <Col>
                        <Button block variant="outline-primary" id="6" name="6" onClick={e => this.props.onClick(e.target.name)}>6</Button>
                    </Col>
                </Row>
                <Row className="text-center mt-3">
                    <Col>
                        <Button block variant="outline-primary" id="7" name="7" onClick={e => this.props.onClick(e.target.name)}>7</Button>
                    </Col>
                    <Col>
                        <Button block variant="outline-primary" id="8" name="8" onClick={e => this.props.onClick(e.target.name)}>8</Button>
                    </Col>
                    <Col>
                        <Button block variant="outline-primary" id="9" name="9" onClick={e => this.props.onClick(e.target.name)}>9</Button>
                    </Col>
                </Row>
                {/* <Row className="text-center mt-3">
                    <Col>
                        <Button block variant="outline-primary" id="clear" name="C" disabled={((parseInt(result)*1) === 0 || result === '') ? true : false} onClick={e => this.props.onClick(e.target.name)}>C</Button>
                    </Col>
                    <Col>
                        <Button block variant="outline-primary" id="0" name="0" onClick={e => this.props.onClick(e.target.name)}>0</Button>
                    </Col>
                    <Col>
                        <Button block variant="outline-primary" id="bksp" name="bksp" disabled={((parseInt(result)*1)=== 0 || result === '') ? true : false} onClick={e => this.props.onClick("bksp")}><BsBackspace /></Button>
                    </Col>
                </Row> */}
                <Row className="text-center mt-3">
                    <Col>
                        <Button block variant="outline-primary" id="clear" name="C"
                            disabled={mode === 'operator' ? (result === '' ? true : false) : ((parseInt(result) * 1) === 0 || result === '') ? true : false}
                            onClick={e => this.props.onClick(e.target.name)}>
                            C
                        </Button>
                    </Col>
                    <Col>
                        <Button block variant="outline-primary" id="0" name="0"
                            onClick={e => this.props.onClick(e.target.name)}>
                            0
                        </Button>
                    </Col>
                    <Col>
                        <Button block variant="outline-primary" id="bksp" name="bksp"
                            disabled={mode === 'operator' ? (result === '' ? true : false) : ((parseInt(result) * 1) === 0 || result === '') ? true : false}
                            onClick={() => this.props.onClick('bksp')}>
                            <BsBackspace />
                        </Button>
                    </Col>
                </Row>
            </>
        );
    }
}


export default Keypad;
